import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';
import { ApiResponse } from '../types/api/api-response.interface';

export function formLogin(data: {
  username: string;
  password: string;
}): Promise<AxiosResponse<ApiResponse<string>>> {
  return AxiosProvider.adminApiClient.post(`/auth/login`, data, {
    withCredentials: true,
  });
}

export function refreshToken(): Promise<AxiosResponse<ApiResponse<string>>> {
  return AxiosProvider.adminApiClient.post(`/auth/refresh-token`);
}

export function logout(): Promise<AxiosResponse<ApiResponse<void>>> {
  return AxiosProvider.adminApiClient.post(`/auth/logout`);
}

export function getLoginProfile(): Promise<AxiosResponse<ApiResponse<string>>> {
  return AxiosProvider.adminApiClient.get(`/auth/get-login-profile`);
}
export default {
  async getUserRoles(): Promise<AxiosResponse<ApiResponse<string[]>>> {
    return AxiosProvider.adminApiClient.get(`/auth/authorities`);
  },
  getLoginProfile,
};
